'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagGsAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#07319C" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M24.6668 14.6667C25.4032 14.6667 26.0002 13.7712 26.0002 12.6667C26.0002 11.5621 25.4032 10.6667 24.6668 10.6667C23.9304 10.6667 23.3335 11.5621 23.3335 12.6667C23.3335 13.7712 23.9304 14.6667 24.6668 14.6667Z",
          fill: "#1E1E1E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M24.0001 15.3333C24.7365 15.3333 25.3334 14.4379 25.3334 13.3333C25.3334 12.2287 24.7365 11.3333 24.0001 11.3333C23.2637 11.3333 22.6667 12.2287 22.6667 13.3333C22.6667 14.4379 23.2637 15.3333 24.0001 15.3333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.3333 14.6667C20.0697 14.6667 20.6666 13.7712 20.6666 12.6667C20.6666 11.5621 20.0697 10.6667 19.3333 10.6667C18.5969 10.6667 18 11.5621 18 12.6667C18 13.7712 18.5969 14.6667 19.3333 14.6667Z",
          fill: "#A2ADB0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.0001 15.3333C20.7364 15.3333 21.3334 14.4379 21.3334 13.3333C21.3334 12.2287 20.7364 11.3333 20.0001 11.3333C19.2637 11.3333 18.6667 12.2287 18.6667 13.3333C18.6667 14.4379 19.2637 15.3333 20.0001 15.3333Z",
          fill: "#4F4F4F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22 16.6667C23.1046 17.3333 24 17.0349 24 16.6667C24 16.2985 23.1046 16 22 16C20.8954 16 20 16.2985 20 16.6667C20 17.0349 20.8954 17.3333 22 16.6667Z",
          fill: "#FEC241"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M24.6667 8.66667C25.4031 8.66667 26 8.06971 26 7.33333C26 6.59695 25.4031 6 24.6667 6C23.9303 6 23.3333 6.59695 23.3333 7.33333C23.3333 8.06971 23.9303 8.66667 24.6667 8.66667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22 7.33335C22.7364 7.33335 23.3333 6.7364 23.3333 6.00002C23.3333 5.26364 22.7364 4.66669 22 4.66669C21.2636 4.66669 20.6667 5.26364 20.6667 6.00002C20.6667 6.7364 21.2636 7.33335 22 7.33335Z",
          fill: "#A84B14"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22 6.33335C22.7364 6.33335 23.3333 5.7364 23.3333 5.00002C23.3333 4.26364 22.7364 3.66669 22 3.66669C21.2636 3.66669 20.6667 4.26364 20.6667 5.00002C20.6667 5.7364 21.2636 6.33335 22 6.33335Z",
          fill: "#CFB063"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22 16.6667C22.7364 16.6667 23.3333 16.0697 23.3333 15.3333C23.3333 14.597 22.7364 14 22 14C21.2636 14 20.6667 14.597 20.6667 15.3333C20.6667 16.0697 21.2636 16.6667 22 16.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.3333 8.66667C20.0697 8.66667 20.6667 8.06971 20.6667 7.33333C20.6667 6.59695 20.0697 6 19.3333 6C18.597 6 18 6.59695 18 7.33333C18 8.06971 18.597 8.66667 19.3333 8.66667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20 9.99997C20.7364 9.99997 21.3333 9.40303 21.3333 8.66665C21.3333 7.93027 20.7364 7.33331 20 7.33331C19.2636 7.33331 18.6667 7.93027 18.6667 8.66665C18.6667 9.40303 19.2636 9.99997 20 9.99997Z",
          fill: "#2D42FF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M24 9.99997C24.7364 9.99997 25.3333 9.40303 25.3333 8.66665C25.3333 7.93027 24.7364 7.33331 24 7.33331C23.2636 7.33331 22.6667 7.93027 22.6667 8.66665C22.6667 9.40303 23.2636 9.99997 24 9.99997Z",
          fill: "#2D42FF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.3333 12C26.0697 12 26.6667 11.4031 26.6667 10.6667C26.6667 9.93027 26.0697 9.33331 25.3333 9.33331C24.597 9.33331 24 9.93027 24 10.6667C24 11.4031 24.597 12 25.3333 12Z",
          fill: "#E3DC3D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.3333 10L20.6667 10.6667H23.3333L22.6667 10L23.3333 8.00002C23.3333 8.00002 22.7364 6.66669 22 6.66669C21.2636 6.66669 20.6667 8.00002 20.6667 8.00002L21.3333 10Z",
          fill: "#7F7D7D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22 8.66667C22 8.66667 22.6667 8.51743 22.6667 8.16C22.6667 8.14924 22 8 22 8C22 8 21.3333 8.14924 21.3333 8.16C21.3333 8.51743 22 8.66667 22 8.66667Z",
          fill: "#5D0543"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.0091 11.3412C20.0041 10.9687 20.2877 10.6667 20.6606 10.6667H23.3395C23.7043 10.6667 24.0042 10.9743 24.0091 11.3412L24.0405 13.6682C24.043 13.8514 23.9123 14.0875 23.7637 14.1854L22.3037 15.1479C22.1484 15.2503 21.8928 15.2458 21.7475 15.1479L20.3199 14.1854C20.1681 14.083 20.043 13.8568 20.0405 13.6682L20.0091 11.3412Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M23.3333 15.3333C24.0697 15.3333 24.6667 14.7364 24.6667 14C24.6667 13.2636 24.0698 12.6667 23.3334 12.6667C22.597 12.6667 22 13.2636 22 14C22 14.7364 22.597 15.3333 23.3333 15.3333Z",
          fill: "#225DA4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.6668 14C21.4032 14 22.0002 13.403 22.0002 12.6666C22.0002 11.9303 21.4032 11.3333 20.6668 11.3333C19.9305 11.3333 19.3335 11.9303 19.3335 12.6666C19.3335 13.403 19.9305 14 20.6668 14Z",
          fill: "#225DA4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20 10.6666L23.9999 10.6667L22 14.6666L20 10.6666Z",
          fill: "#0F8012"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22 14C22.7364 14 23.3334 13.403 23.3334 12.6667C23.3334 11.9303 22.7365 11.3333 22.0001 11.3333C21.2637 11.3333 20.6667 11.9303 20.6667 12.6667C20.6667 13.403 21.2636 14 22 14Z",
          fill: "#FFCF44"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: 12, height: 8, fill: "#001C5B" }),
      /* @__PURE__ */ jsx("path", { d: "M11.1 8L0 1.3V0H0.9L12 6.6V8H11.1Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M0.9 8L12 1.3V0H11.1L0 6.6V8H0.9Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M2.8 2.70003L0 1.00003V0.400024L3.8 2.70003H2.8Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M9.2 5.29997L12 6.99997V7.59998L8.2 5.29997H9.2Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M8.29999 2.7L12 0.4V0H11.6L7.29999 2.7H8.29999Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M3.70001 5.3L0 7.6V8H0.4L4.70001 5.3H3.70001Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("rect", { x: 4.69995, width: 2.6, height: 8, fill: "white" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 5.29999,
          width: 2.6,
          height: 12,
          transform: "rotate(-90 0 5.29999)",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { x: 5.19995, width: 1.6, height: 8, fill: "#CA0028" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 4.79999,
          width: 1.6,
          height: 12,
          transform: "rotate(-90 0 4.79999)",
          fill: "#CA0028"
        }
      )
    ]
  }
);
const VpFlagGsAsset = forwardRef(FlagGsAsset);

export { VpFlagGsAsset as default };
